// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3wxhR","header":"ReportDetails_header__2xRiF","title":"ReportDetails_title__2lbcO","left":"ReportDetails_left__2lWN_"};